const transitions = {
    focus: 'opacity 200ms ease-in-out',
};

export default transitions;
